__turbopack_context__.v({
  "fieldWrapper": "FormSparkForm-module-scss-module___3tbCa__fieldWrapper",
  "form": "FormSparkForm-module-scss-module___3tbCa__form",
  "radioGroup": "FormSparkForm-module-scss-module___3tbCa__radioGroup",
  "success": "FormSparkForm-module-scss-module___3tbCa__success",
  "wrapper": "FormSparkForm-module-scss-module___3tbCa__wrapper",
});
